import { PropsWithChildren } from 'react';
import { getHeaderStyles } from './HeaderStyles';

export function BaseHeader({ children }: PropsWithChildren): JSX.Element {
    return <header css={getHeaderStyles}>{children}</header>;
}
